window.addCameraButton = function addCameraButton(trixEvent){
  var element = document.querySelector("trix-editor")
  var buttonHTML, buttonRow;

  buttonHTML =  '<span class="trix-button-group trix-button-group--camera" data-trix-button-group="camera">'
  buttonHTML += '<label class="trix-button trix-button--icon trix-button--icon-cam">Foto'
  buttonHTML += '<input class="hidden" type="file" id="js-camera" accept="image/*" capture="capture"></label></span>'

  buttonRow = trixEvent.target.toolbarElement.querySelector(".trix-button-row");
  buttonRow.insertAdjacentHTML("beforeend", buttonHTML)

  var cameraFileField = document.querySelector("#js-camera");

  cameraFileField.onchange = function (event) {
    var files = event.currentTarget.files;
    element.editor.insertFile(files[0])
  };
}

window.addEmbedVideoButtonAndDialog = function addEmbedVideoButtonAndDialog(trixEvent, Trix){
  var editorToolbar = trixEvent.target.parentNode.querySelector("trix-toolbar");

  // Button html
  var buttonHTML, buttonGroup;
  buttonHTML = '<button type="button" class="trix-button trix-button--icon trix-button--icon-embed" data-trix-attribute="embed" title="Embed video" tabindex="-1">Embed Video</button>'

  buttonGroup = editorToolbar.querySelector("[data-trix-button-group='text-tools']");
  buttonGroup.insertAdjacentHTML("beforeend", buttonHTML)

  // Dialog html
  var dialogHTML, dialogsGroup;

  dialogHTML = '<div class="trix-dialog trix-dialog--embed" data-trix-dialog="embed-href" data-trix-dialog-attribute="embed-href">'
  dialogHTML +=   '<div class="trix-dialog__embed-fields">'
  dialogHTML +=     '<input type="url" name="embed-href" class="trix-input trix-input--dialog" placeholder="Añade la url de un video de Youtube" aria-label="URL" data-trix-input="">'
  dialogHTML +=     '<div class="trix-button-group">'
  dialogHTML +=       '<input type="button" class="trix-button trix-button--dialog trix-button--dialog-add-embed" value="Añadir">'
  dialogHTML +=     '</div>'
  dialogHTML +=     '<div class="embed-error hidden" data-error-container="">La url no es válida</div>'
  dialogHTML +=   '</div>'
  dialogHTML += '</div>'

  dialogsGroup = editorToolbar.querySelector("[data-trix-dialogs]");
  dialogsGroup.insertAdjacentHTML("beforeend", dialogHTML)

  // Dialog logic
  var button = editorToolbar.querySelector('.trix-button--icon-embed')
  var urlInput = editorToolbar.querySelector('input[name="embed-href"');

  button.addEventListener('click', function(event){
    var dialog = editorToolbar.querySelector('.trix-dialog--embed')
    if (button.classList.contains('trix-active')) {
      dialog.classList.add("trix-active")
      dialog.setAttribute('data-trix-active', '')
      urlInput.removeAttribute('disabled')
    } else {
      dialog.classList.remove("trix-active")
      dialog.removeAttribute('data-trix-active')
    }
  });

  var dialogButton = editorToolbar.querySelector('.trix-button--dialog-add-embed');

  dialogButton.addEventListener('click', function(evt){
    var url = urlInput.value;
    var videoId = getVideoId(url);

    if (videoId) {
      editorToolbar.querySelector('[data-error-container]').classList.add('hidden');
      insertVideoPreview(videoId, trixEvent.target.editor, Trix);
      urlInput.value = '';
    } else {
      editorToolbar.querySelector('[data-error-container]').classList.remove('hidden');
    }
  });
}

function getVideoId(url) {
  var youtubeMatch = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
  var match = url.match(youtubeMatch);

  if (match){
    return match[5];
  }
}

// image preview
function insertVideoPreview(videoId, editor, Trix){
  var img = '<img data-trix-embed src="http://img.youtube.com/vi/'+videoId+'/0.jpg" />';
  var attachmentImg = new Trix.Attachment({ content: img });
  editor.insertAttachment(attachmentImg);

  var content = '<iframe data-trix-embed width="560" height="315" src="https://www.youtube.com/embed/'+videoId+'" allowfullscreen></iframe>';
  var attachmentIFrame = new Trix.Attachment({ content: content });
  editor.insertAttachment(attachmentIFrame);
}
